module.exports = __webpack_public_path__ + "static/media/skull.6979617b.png";